// Productions State
import i18n from '@/i18n'

export default {
  productionsList: [],
  productionInfo: {},
  unclosedProductionsCount: 0,
  shiftTimes: [{ text: i18n.t('Morning'), value: 'Morning' }, { text: i18n.t('Evening'), value: 'Evening' }]
}
